/**
 * The quotes tab: the list of quotes, or one quote's page.
 *
 * A tab of its own rather than a card inside Invoices, which is where the
 * estimates table once lived, for two reasons. `PORTAL_TABS` drew no tab for
 * the `estimates` module, so a contact granted quotes and NOT invoices had the
 * whole module served by the API and reachable from nowhere. And this screen
 * does something: a read-only list belongs beside the invoices it resembles, a
 * screen where the client commits to a price belongs on its own door.
 *
 * Which quote is open is URL state (`?doc=<id>`), the same rule the invoices
 * tab follows - so an answer can be linked to, reloaded into and left with the
 * browser's Back button.
 */
import { useSearchParams } from "react-router-dom";
import { keepPreview } from "../../../lib/previewMode";
import { EstimateList } from "./EstimateList";
import { EstimatePage } from "./EstimatePage";

export function EstimatesSection() {
  const [params, setParams] = useSearchParams();
  const docId = params.get("doc");

  // Every rewrite goes through `keepPreview`: `setParams` replaces the whole
  // query string, and a staff preview would otherwise drop its token.
  const open = (id: string) => setParams(keepPreview({ tab: "estimates", doc: id }));
  const back = () => setParams(keepPreview({ tab: "estimates" }));

  if (docId) return <EstimatePage key={docId} id={docId} onBack={back} />;
  return <EstimateList onOpen={open} />;
}
